import '@babel/polyfill';
import Vue from 'vue';
import VueViewer from 'v-viewer';
import { Message, Notice, Modal } from 'iview';
import store from './store';
import App from './App';
import router from './router';
import '@/styles/tailwind.css';
import '@/styles/custom-theme.less';
import '@/styles/index.less';
import types from '@/store/types';
import 'viewerjs/dist/viewer.css';
import {
  getUserType, pcEntranceProcess, providerEntranceProcess, freeEntranceProcess
} from './components/login/loginUtil';
import Mixin from './mixins';
import '@/assets/iconfont/iconfont';
import PhoneVerifyPlugin from '@/plugins/phoneVerify';
import '@/utils/TCaptcha.js';
import ShowTCaptchaPlugin from '@/plugins/showTCaptcha/showTCaptcha';

Vue.mixin(Mixin);
Vue.config.productionTip = false;
Vue.prototype.$message = Message;
Vue.prototype.$message.config({
  duration: 5
});
Vue.prototype.$Notice = Notice;
Vue.prototype.$Modal = Modal;
Vue.use(VueViewer, {
  defaultOptions: {
    toolbar: {
      zoomIn: 1,
      zoomOut: 1,
      oneToOne: 1,
      // reset: 1,
      prev: 1,
      play: 1,
      next: 1,
      rotateLeft: 1,
      rotateRight: 1,
      flipHorizontal: 1,
      flipVertical: 1,
    }
  }
});
Vue.use(PhoneVerifyPlugin);
Vue.use(ShowTCaptchaPlugin);

// 用于控制宣传页的显示，显示3次后就不再显示
if (!localStorage.getItem('showTimes')) {
  localStorage.setItem('showTimes', 1);
}
router.beforeEach((to, from, next) => {
  /**
   *1、 如果路由ignoreToken为true，不需验证，直接进入
   */
  if (to.meta.ignoreToken) {
    next();
    return;
  }

  // 外部系统内嵌页打开
  if (to.name === 'ProductInfo' && to.query.p) {
    const params = JSON.parse(to.query.p);
    localStorage.setItem('token', params.token);
    sessionStorage.setItem('outerSystem', params.fromSystem);
  }

  const userType = getUserType();
  if (userType.type === 0) {
    /**
     *1、来自药店端
     */
    store.commit(types.UPDATE_PCTOKEN, userType.pcToken);
    store.commit(types.UPDATE_USER_BRIEF, { companyType: 0 });
    pcEntranceProcess(userType, to, next);
  } else if (userType.type === 1) {
    /**
     *1、来自供应商端
     */
    store.commit(types.UPDATE_USER_BRIEF, { companyType: 1 });
    providerEntranceProcess(userType, to, next);
  } else {
    freeEntranceProcess(to, next);
  }
});

router.afterEach((to) => {
  if (to.meta.menuName) {
    store.commit('updateActiveName', to.meta.menuName);
  }
});

window.addEventListener('unload', () => {
  const userType = getUserType();
  if (userType.type == 0) {
    store.commit(types.UPDATE_TOKEN, '');
  } else if (userType.type == 1) {
    store.commit(types.UPDATE_TOKEN, '');
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});
